import { create } from "zustand";
import { persist } from "zustand/middleware";

const useFilterStore = create(
  persist(
    (set) => ({
      filters: {
        page: 1,
        page_size: 8,
        invoice_type: "",
        invoice_detection_status: "",
        rerun_status: "",
        auto_accepted: "",
        start_date: "",
        end_date: "",
        clickbacon_status: "",
        human_verification: "all",
        vendor: "",
        sort_order: "desc",
        restaurant: "",
        human_verified: "all",
        assigned_to:"",
        token:""
      },
      setFilters: (newFilters) =>
        set((state) => ({
          filters: { ...state.filters, ...newFilters },
        })),
        setToken:(token) =>
        set((state) => ({
          filters: { ...state.filters, token: token },
        })),
        
      setDefault: () =>
        set({
          filters: {
            page: 1,
            page_size: 8,
            invoice_type: "",
            invoice_detection_status: "",
            rerun_status: "",
            auto_accepted: "",
            start_date: "",
            end_date: "",
            clickbacon_status: "",
            human_verification: "all",
            vendor: "",
            sort_order: "desc",
            restaurant: "",
            human_verified: "all",
            assigned_to:"",
            token:""
          },
        }),
    }),
    {
      name: "filter-store", // Key in localStorage
      partialize: (state) => ({ filters: state.filters }), // Optionally, only persist `filters`
    }
  )
);

export default useFilterStore;
